import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetShipmentsMetadataFactoryDependencies = {
  repository: ShipmentRepository
  enableNewShipmentsEndpoint: boolean
}

type Params = {
  config: Partial<HttpClientConfig>
}

export function getShipmentsMetadataFactory({
  repository,
  enableNewShipmentsEndpoint,
}: GetShipmentsMetadataFactoryDependencies) {
  return async function getShipmentsMetadata({ config }: Params) {
    try {
      return await repository.getShipmentsMetadata(config, enableNewShipmentsEndpoint)
    } catch (error) {
      throw new Error('Could not get shipments metadata', { cause: error as Error })
    }
  }
}

export function getShipmentsMetadata(params: Params, enableNewShipmentsEndpoint: boolean) {
  let httpClient

  if (enableNewShipmentsEndpoint) {
    httpClient = createAgnosticHttpClient()
  } else {
    httpClient = new HttpClient(API_URL)
  }

  const repository = new ShipmentRepository({ httpClient })
  const newGetShipmentsMetadata = getShipmentsMetadataFactory({
    repository,
    enableNewShipmentsEndpoint,
  })
  return newGetShipmentsMetadata(params)
}
